/** @format */

import React from "react";
import { Box } from "./MuiCompat";
import PageBackground from "./PageBackground";
import Hero from "./Hero";
import Problem from "./Problem";
import Navigate from "./Navigate";
import Capabilities from "./Capabilities";
import Multiplayer from "./Multiplayer";
import Trust from "./Trust";
import PartnerSection from "./PartnerSection";

const Home: React.FC = () => {
  return (
    <>
      <PageBackground />
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <Hero />
        <Problem />
        <Navigate />
        <Capabilities />
        <Multiplayer />
        <Trust />
        <PartnerSection />
      </Box>
    </>
  );
};

export default Home;
